import React, { useEffect, useRef, useState, } from 'react';
import './NoteBookGenAI.css';
import './NoteBookAuthoring.css'
import { CreateNBGenAIModal } from '../../components/GenAINoteBook/CreateNBGenAIModal';
import NoteBookAuthoringIndex from '../../components/GenAINoteBook/NoteBookAuthoringIndex';
import TableNoteBook from '../../components/GenAINoteBook/TableNoteBook';
import GenAIHomeFooter from '../../components/footer/GenAIHomeFooter';
import {
    UserData
} from "../../auth/Authorization";
import NoteBookProjectService from '../../services/NoteBookProjectSevice';
import threadingService from '../../services/threadingService';
import { imsLoader, JJ_IMedical_icon } from '../../assets';
import AlertMessagePopUpModal from '../../components/GenAIPopUp/AlertMessagePopUpModal';
import { useHistory, useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { LocationOrigin } from '../../utils/utilityServices';
import axios from 'axios';
import { Authentication } from '../../utils/authenticationUtilityServices';
import ApiServices from '../../utils/apiServices';
import Pagination from "../../components/Paginate/Pagination";
import Services from "../../utils/services";
import BoxViewNotebook from "../../components/GenAINoteBook/BoxViewNotebook";
import { v4 as uuidv4 } from 'uuid';
import { Modal } from "react-bootstrap";
import moment from "moment";
import {  Link } from 'react-router-dom';
import { isShowAuthoring } from '../../utils/utilityServices';

const api = new NoteBookProjectService()
const apiServices = new ApiServices();
const _ItemsPerPage = 15;
let _timeoutTime = (1000 * (300));
var guid = uuidv4();
var _threadGuid = uuidv4();
let _locationOrigin = LocationOrigin;
//_locationOrigin = 'https://predev-ims.jnj.com';
export default function NotebookGenAIDashboard() {
    let _timeoutTime = (1000 * (300));
    //states of the component
    const [userExists, setUserExists] = useState(false);
    const [createNoteBook, setCreateNoteBook] = useState(false);
    const [selectedTab, setSelectedTab] = useState(0);
    const [noteBookName, setNoteBookName] = useState('')
    const [attachedfile, setAttachedFile] = useState([]);
    const [sessionId, setSessionId] = useState('');
    const [isFromCreate, setIsFromCreate] = useState(false);
    const [selectedProjectType, setSelectedProjectType] = useState();
    const [isTableView, setTableView] = useState(false);
    const [threadId, setThreadId] = useState('');
    //---Existing Project-----//
    const [isProjectProcessing, setIsProjectProcessing] = useState(false);

    const [projectResponseLegacy, setProjectResponseLegacy] = useState([]);
    const [projectResponse, setProjectResponse] = useState([]);

    const [projectCurrentPage, setProjectCurrentPage] = useState('1');
    const [projectItemsPerPage, setProjectItemsPerPage] = useState(_ItemsPerPage);
    const [projectDocumentCount, setProjectDocumentCount] = useState(0);

    const [searchKeywordProject, setSearchKeywordProject] = useState('');
    const [sampleProjects, setSampleProject] = useState([]);
    const [viewMoreId, setViewMoreId] = useState([]);
    const [isExistingProject, setIsExistingProject] = useState(false);
    const [projectResponseFromIndex, setProjectResponseFromIndex] = useState([])
    //Alert
    const [alertMessageShowModal, setAlertMessageShowModal] = useState(false);
    const [alertMessageContent, setAlertMessageContent] = useState('');
    const [alertMessageModelColor, setAlertMessageModelColor] = useState('');
    const [customWidth, setCustomWidth] = useState(window.innerWidth);
    const [customHeight, setCustomHeight] = useState(window.innerHeight);
    const [sortByValue, setSortByValue] = useState("MostRecent");
    const [sortField, setSortField] = useState("added_on desc");
    //Ref
    const boxRef = useRef(null);
    const [spinnerMessage, setSpinnerMessage] = useState('Please wait while loading the projects.')

    let userid = '';
    const history = useHistory();
    const location = useLocation();
    useEffect(async () => {
        try {
            document.title = 'iMedical Search';
            window.scrollTo(0, 0);

            userid = JSON.parse(localStorage.getItem('username'));
            let wwid = JSON.parse(localStorage.getItem('wwid'));
            let userExists = localStorage.getItem('userExists');
            let service = new Services();
            let apiService = new ApiServices();
            service.logService(`Gen Ai Notebook Home page successfully mounted for ${userid.toLowerCase()}`, 'info');
            if (userExists && isShowAuthoring()) {
                setUserExists(userExists);

                let approvedState = await apiService.getUserStatus(wwid);
                let apiRes = await apiService.getUserApprovedRegionRole(wwid);
                if (approvedState.status === 'Accepted') {
                    localStorage.setItem('region', approvedState.regions);
                    localStorage.setItem('function', JSON.stringify(approvedState.profession));

                }
                else {
                    if (apiRes) {
                        localStorage.setItem('region', apiRes.region);
                        localStorage.setItem('function', JSON.stringify(apiRes.function));
                    }
                    else {
                        localStorage.setItem('region', approvedState.regions);
                        localStorage.setItem('function', JSON.stringify('Commercial'));
                    }

                }

            } else {
                console.log('Access Denied');
                history.push('/');
            }

        } catch (error) {

        }

    }, []);
    useEffect(() => {
        const updateDimensions = () => {
            setCustomWidth(window.innerWidth);
            setCustomHeight(window.innerHeight)
        }
        // Add event listener
        window.addEventListener('resize', updateDimensions);
        // Cleanup function: remove event listener when component unmounts
        return () => {
            let service = new Services();
            window.removeEventListener('resize', updateDimensions);
            service.logService(`Gen Ai Home page successfully unmounted for ${userid.toLowerCase()}`, 'info')
        };
    }, []); // Empty dependency array ensures this effect runs only once on mount

    useEffect(() => {
        getExistingProjectLists(projectCurrentPage, projectItemsPerPage, sortField);
    }, [])

    /*useEffect(()=>{
        document.addEventListener('click',(e)=>handleClickDoc(e.target));
        return () => document.removeEventListener('click',handleClickDoc)
    })*/


    /*const handleClickDoc = (target) =>{
        console.log(target)
        if(boxRef.current && !boxRef.current.contains(target)){
            setViewMoreId([])
        }
    }*/
    const successAlertMessage = (message) => {
        setAlertMessageShowModal(true)
        setAlertMessageContent(message);
        setAlertMessageModelColor("#00c12c");
    }
    const errorAlertMessage = (message) => {
        setAlertMessageShowModal(true)
        setAlertMessageContent(message);
        setAlertMessageModelColor("#de1327");
    }
    const closeAlertMessage = () => {
        setAlertMessageShowModal(false)
        setAlertMessageContent('');
        setAlertMessageModelColor('');
        getExistingProjectLists(projectCurrentPage, projectItemsPerPage, sortField);
    }
    const handleTabClick = (selectTab) => {
        let allProjectData = projectResponseLegacy;
        let filterProjectData = [];
        if (selectTab === 0) {
            filterProjectData = allProjectData
        } else if (selectTab === 1) {
            filterProjectData = allProjectData.filter(x => x.shared_from_email === null)
        } else if (selectTab === 2) {
            filterProjectData = allProjectData.filter(x => x.shared_from_email !== null)
        }
        setSelectedTab(selectTab)
        setProjectResponse(filterProjectData)
        setDisplayProject(filterProjectData)
    }
    const handleSaveNoteBookInDB = async (noteBookName, sessionID, selectedProjectType, threadID) => {
        setIsProjectProcessing(true)
        try {
            let res = await apiServices.postGenAINoteBook(UserData?.sub, noteBookName, sessionID, selectedProjectType.project_type_name, threadID, false)
            if (res) {
                setIsProjectProcessing(false)
            }
        } catch (error) {
            console.log(error)
        }
    }
    const handleAddSourceToDB = async (sessionID, textFile) => {
        setIsProjectProcessing(true)
        let notebookName = `${moment().format("YYYYMMDDhhmmss")}.txt`
        try {
            let res = await apiServices.postGenAINootBookSourceText(sessionID, textFile, notebookName);
            if (res) {
                setIsProjectProcessing(false)
            }
        } catch (error) {
            console.log(error)
        }
    }
    const multiSourceTextUpload = async (sessionID, text) => {
        // let LocationOrigin = 'https://predev-ims.jnj.com';
        // var url = `${LocationOrigin}${process.env.REACT_APP_IMS_API_MULTI_ANSWERS}multi_upload`
        let newFileguid = uuidv4();
        return newFileguid

    }
    const handleCreateNew = async (attachedfile, sessionID, noteBookName, selectedProjectType, threadID, promptsNew, textFile) => {
        setAttachedFile(attachedfile);
        setSessionId(sessionID);
        setNoteBookName(noteBookName);
        //setIsFromCreate(true);
        setSelectedProjectType(selectedProjectType);
        setThreadId(threadID);
        let fileguid = multiSourceTextUpload(sessionID, textFile)
        if (textFile.trim().length > 0) {
            await handleAddSourceToDB(sessionID, textFile, fileguid)
        }
        await handleSaveNoteBookInDB(noteBookName, sessionID, selectedProjectType, threadID)
        let data = {
            sessionID: sessionID,
            threadID: threadID,
            noteBookName: noteBookName.trim(),
            selectedProjectType: selectedProjectType,
            attachedFiles: attachedfile,
            //isExistingProject: false,
            prompts: promptsNew
        }
        history.push({
            pathname: `/Authoring-AI-Search`,
            state: data // your data array of objects
        })
    }
    const handleCreateNoteBook = () => {
        setCreateNoteBook(true)
    }
    const setDisplayProject = (res) => {
        let sampleProjectNew = res.map((val) => {
            let date1 = new Date(val.added_on);
            const options = {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
            };
            const formattedDate = date1.toLocaleDateString('en-US', options);
            return (
                {
                    id: val.session_id,
                    title: val.notebook_name,
                    date: formattedDate,
                    /*people: 4,*/
                    color: 'accent'
                })
        })
        setSampleProject(sampleProjectNew)
    }



    const getExistingProjectLists = async (_projectCurrentPage, _projectItemsPerPage, _sortField) => {
        setIsProjectProcessing(true)
        const ts = new threadingService();
        if (UserData && UserData.sub) {
            let from = parseInt(_projectCurrentPage) * parseInt(_projectItemsPerPage) - parseInt(_projectItemsPerPage);
            let size = parseInt(_projectItemsPerPage)
            let responseFromDB = await apiServices.getGenAINoteBook(UserData.sub, from, size, _sortField);
            let responseFromIndex = await api.getExistingProjectLists(UserData.sub, 0, 15, searchKeywordProject)
            let responseTotalCountOfGenAINoteBook = await apiServices.getTotalCountOfGenAINoteBook(UserData.sub);
            if (responseTotalCountOfGenAINoteBook && responseTotalCountOfGenAINoteBook.length > 0) {
                setProjectDocumentCount(parseInt(responseTotalCountOfGenAINoteBook[0].count))
            } else {
                setProjectDocumentCount(0)
            }
            if (responseFromDB && responseFromIndex && responseFromIndex.data) {
                setProjectResponse(responseFromDB)
                setProjectResponseLegacy(responseFromDB)
                setProjectResponseFromIndex(responseFromIndex.data.hits.hits)
                //setProjectResponse(response.data.hits.hits) *added from db data
                setIsProjectProcessing(false);
                setDisplayProject(responseFromDB)
                //setDisplayProject(response.data.hits.hits) *added from db data
            } else {
                setProjectDocumentCount(0)
                setProjectResponse([])
                setIsProjectProcessing(false)
            }
        } else {
            setProjectDocumentCount(0);
            setProjectResponse([]);
            setIsProjectProcessing(false);
        }
    }
    const ViewMore = (indi) => {
        if (viewMoreId.indexOf(indi) === -1) {
            setViewMoreId([indi])
        } else {
            let filterViewMore = viewMoreId.filter(x => x !== indi)
            setViewMoreId(filterViewMore)
        }
    }
    const handleViewExisting = async (sessionID) => {
        setSessionId(sessionID);
        //setIsExistingProject(true);
        //Checking if session id present in indexes or not
        let isPresent = projectResponseFromIndex.filter(val => val._source.notebookinfo.session_id === sessionID).length > 0 ? true : false;
        if (isPresent) {
            let projectDB = projectResponse.filter(val => val.session_id === sessionID)[0];
            let project = projectResponseFromIndex.filter(val => val._source.notebookinfo.session_id === sessionID)[0];
            let session_id = project._source.notebookinfo.session_id;
            let data = {
                sessionID: project._source.notebookinfo.session_id,
                threadID: project._source.notebookinfo.thread_id,
                noteBookName: projectDB.notebook_name.trim(),
                selectedProjectType: (project._source.notebookinfo.projectType) ? project._source.notebookinfo.projectType : {},
                //attachedFiles: project._source.notebookinfo.attachedFiles,
                isExistingProject: true
            }
            history.push({
                pathname: `/Authoring-AI-Search/${session_id}`,
                state: data // your data array of objects
            })
        } else {
            let project = projectResponse.filter(val => val.session_id === sessionID)[0];
            const services = new ApiServices();
            let res = await services.getAllProjectName();
            let filterProjectType = res.filter(val => val.project_type_name === project.project_type)[0]
            let session_id = project.session_id;
            let data = {
                sessionID: project.session_id,
                threadID: project.thread_id,
                noteBookName: project.notebook_name.trim(),
                selectedProjectType: (filterProjectType) ? filterProjectType : {},
                attachedFiles: [],
                isExistingProject: true
            }
            history.push({
                pathname: `/Authoring-AI-Search/${session_id}`,
                state: data // your data array of objects
            })
        }


    }
    const handleDeleteFileFromS3 = async (session_id) => {
        //let url = `https://localhost:44307/api/NotebookService/S3File/Delete/my-new-folder1`;
        let url = `${_locationOrigin}/api/NotebookService/S3File/Delete/${session_id}`
        if (window.location.origin === 'https://predev-ims.jnj.com') {
            url = `${window.location.origin}/api/NotebookService/S3File/Delete/${session_id}`
        }
        const _headers = {
            'content-type': 'multipart/form-data'
        }
        if (await Authentication.isAccessTokenAvailable()) {
            const token = await Authentication.getAccessToken();
            _headers.Authorization = `Bearer ${token}`;
        }
        let config = {
            method: 'DELETE',
            url: url,
            headers: _headers,
            // data: formData,
            timeout: _timeoutTime
        }
        await axios(config).then((resp) => {
            // console.log("resp", resp)
        }).catch((error) => {
            //console.log("error", error)
        }).finally(() => {
            // console.log("in finally")
        });

    }
    const deleteNoteBookFromDB = async (session_id) => {
        try {
            let res = await apiServices.deleteGenAINoteBook(session_id)
            setIsProjectProcessing(false)
            setSpinnerMessage('Please wait while loading the projects.');    
        } catch (error) {
            console.log(error)
        }
    }
    const handleDeleteExisting = async (session_id) => {
        setIsProjectProcessing(true)
        setSpinnerMessage('Please wait while deleting the project.');
        let response = await api.deleteNoteBookProjectBySessionId(UserData.sub, session_id)
        if (response.data.statusCode === 200) {
            /*if (window.location.origin.startsWith('http://localhost:3000')) {}*/
            await handleDeleteFileFromS3(session_id);
            await deleteNoteBookFromDB(session_id)

            successAlertMessage('Project deleted successfully')
        } else {
            errorAlertMessage('Something went wrong. Please try later')
        }
    }
    const handlePageChange = (currentPage) => {
        try {
            window.scrollTo({ behavior: "smooth", top: "0px" });
            setProjectCurrentPage(currentPage);
            getExistingProjectLists(currentPage, projectItemsPerPage, sortField)

        } catch (error) {
            //this.setState({ error: error });
        }
    };
    const handleChangeSelectSortBy = (e) => {
        try {
            if (e.target.value === "MostRecent") {
                setSortByValue("MostRecent");
                setSortField("added_on desc")
                getExistingProjectLists(1, _ItemsPerPage, "added_on desc")

            } else if (e.target.value === "Alphabetical") {
                setSortByValue("Alphabetical");
                setSortField("notebook_name")
                getExistingProjectLists(1, _ItemsPerPage, "notebook_name");
            }
            setProjectCurrentPage('1');
            setProjectItemsPerPage(_ItemsPerPage);
            setProjectDocumentCount(0);

        } catch (error) {

        }
    };

    return (
        <>
            <div className='notebook-genai-pages' style={{ background: (!isFromCreate) ? '#FFFF' : '#F9F8F7' }}>
                <header className='notebook-genai-header' role="banner">
                    <div className='notebook-genai-headerInner'>
                        <div className="pubmed-main-ask-question-headerWithBanner-left">
                            <Link to="/">
                                <img
                                    className="bm-agent-image"
                                    src={JJ_IMedical_icon}
                                    alt="iMS profile image"
                                    style={{ padding: '2.5px', margin: '0.75%', height: "34px" }}
                                />
                            </Link>
                        </div><div class='notebook-authoring-conc'>
                            <div className='notebook-genai-brandBlock'>
                                <div className='notebook-genai-brandLine'>
                                    {/*<span className='notebook-genai-brandSmall'>Content Center-AI</span>*/}
                                    <span className='notebook-genai-brandSmall'>Authoring.AI</span>
                                </div>
                            </div>
                            <div className='notebook-genai-userArea'>
                                <button
                                    className='notebook-genai-profile'
                                    aria-label="Open profile menu"
                                    title="User menu"
                                >
                                    <span className='notebook-genai-profileInitials'>{UserData.jnjMSUsername.slice(0, 2)}</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </header>

                {!isFromCreate && attachedfile.length === 0 && !isExistingProject && <nav className='notebook-genai-subNav' aria-label="Primary">
                    <div className='notebook-genai-tabs'>
                        <button className={(selectedTab === 0) ? 'notebook-genai-tabActive' : 'notebook-genai-tab'} onClick={() => handleTabClick(0)}>All</button>
                        <button className={(selectedTab === 1) ? 'notebook-genai-tabActive' : 'notebook-genai-tab'} onClick={() => handleTabClick(1)}>Projects</button>
                        {/* <button className={(selectedTab === 2) ? 'notebook-genai-tabActive' : 'notebook-genai-tab'} onClick={() => handleTabClick(2)}>Shared With Me</button>
                     */}
                    </div>

                    <div className='notebook-genai-actions'>
                        <div className='notebook-genai-filterGroup' role="group" aria-label="List filters">
                            <div className='notebook-genai-iconBtn' style={!isTableView ? { background: '#EB1700' } : { background: 'none' }} title="Grid View" onClick={() => { setTableView(false) }} >
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                    <path d="M5.59975 2H3.06651C2.69315 2 2.50647 2 2.36387 2.07266C2.23843 2.13658 2.13645 2.23856 2.07254 2.36401C1.99988 2.50661 1.99988 2.6933 1.99988 3.06667V5.6C1.99988 5.97337 1.99988 6.16005 2.07254 6.30266C2.13645 6.4281 2.23843 6.53009 2.36387 6.594C2.50647 6.66667 2.69315 6.66667 3.06651 6.66667H5.59975C5.97311 6.66667 6.15978 6.66667 6.30239 6.594C6.42782 6.53009 6.52981 6.4281 6.59372 6.30266C6.66638 6.16005 6.66638 5.97337 6.66638 5.6V3.06667C6.66638 2.6933 6.66638 2.50661 6.59372 2.36401C6.52981 2.23856 6.42782 2.13658 6.30239 2.07266C6.15978 2 5.97311 2 5.59975 2Z" stroke={isTableView ? "#81766F" : "#ffffff"} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M12.9328 2H10.3996C10.0262 2 9.83955 2 9.69695 2.07266C9.57151 2.13658 9.46953 2.23856 9.40561 2.36401C9.33295 2.50661 9.33295 2.6933 9.33295 3.06667V5.6C9.33295 5.97337 9.33295 6.16005 9.40561 6.30266C9.46953 6.4281 9.57151 6.53009 9.69695 6.594C9.83955 6.66667 10.0262 6.66667 10.3996 6.66667H12.9328C13.3062 6.66667 13.4929 6.66667 13.6355 6.594C13.7609 6.53009 13.8629 6.4281 13.9268 6.30266C13.9995 6.16005 13.9995 5.97337 13.9995 5.6V3.06667C13.9995 2.6933 13.9995 2.50661 13.9268 2.36401C13.8629 2.23856 13.7609 2.13658 13.6355 2.07266C13.4929 2 13.3062 2 12.9328 2Z" stroke={isTableView ? "#81766F" : "#ffffff"} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M12.9328 9.33333H10.3996C10.0262 9.33333 9.83955 9.33333 9.69695 9.406C9.57151 9.46991 9.46953 9.5719 9.40561 9.69734C9.33295 9.83995 9.33295 10.0266 9.33295 10.4V12.9333C9.33295 13.3067 9.33295 13.4934 9.40561 13.636C9.46953 13.7614 9.57151 13.8634 9.69695 13.9273C9.83955 14 10.0262 14 10.3996 14H12.9328C13.3062 14 13.4929 14 13.6355 13.9273C13.7609 13.8634 13.8629 13.7614 13.9268 13.636C13.9995 13.4934 13.9995 13.3067 13.9995 12.9333V10.4C13.9995 10.0266 13.9995 9.83995 13.9268 9.69734C13.8629 9.5719 13.7609 9.46991 13.6355 9.406C13.4929 9.33333 13.3062 9.33333 12.9328 9.33333Z" stroke={isTableView ? "#81766F" : "#ffffff"} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M5.59975 9.33333H3.06651C2.69315 9.33333 2.50647 9.33333 2.36387 9.406C2.23843 9.46991 2.13645 9.5719 2.07254 9.69734C1.99988 9.83995 1.99988 10.0266 1.99988 10.4V12.9333C1.99988 13.3067 1.99988 13.4934 2.07254 13.636C2.13645 13.7614 2.23843 13.8634 2.36387 13.9273C2.50647 14 2.69315 14 3.06651 14H5.59975C5.97311 14 6.15978 14 6.30239 13.9273C6.42782 13.8634 6.52981 13.7614 6.59372 13.636C6.66638 13.4934 6.66638 13.3067 6.66638 12.9333V10.4C6.66638 10.0266 6.66638 9.83995 6.59372 9.69734C6.52981 9.5719 6.42782 9.46991 6.30239 9.406C6.15978 9.33333 5.97311 9.33333 5.59975 9.33333Z" stroke={isTableView ? "#81766F" : "#ffffff"} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </div>
                            <div className='notebook-genai-iconBtn' style={isTableView ? { background: '#EB1700' } : { background: 'none' }} title="Table View" onClick={() => { setTableView(true) }}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 16 16" fill="none">
                                    <path d="M13.9995 8L5.99974 7.99999M13.9995 4L5.99974 3.99999M13.9995 12L5.99974 12M3.33316 7.99999C3.33316 8.36818 3.0347 8.66666 2.66652 8.66666C2.29834 8.66666 1.99988 8.36818 1.99988 7.99999C1.99988 7.6318 2.29834 7.33333 2.66652 7.33333C3.0347 7.33333 3.33316 7.6318 3.33316 7.99999ZM3.33316 3.99999C3.33316 4.36818 3.0347 4.66666 2.66652 4.66666C2.29834 4.66666 1.99988 4.36818 1.99988 3.99999C1.99988 3.63181 2.29834 3.33333 2.66652 3.33333C3.0347 3.33333 3.33316 3.63181 3.33316 3.99999ZM3.33316 12C3.33316 12.3682 3.0347 12.6667 2.66652 12.6667C2.29834 12.6667 1.99988 12.3682 1.99988 12C1.99988 11.6318 2.29834 11.3333 2.66652 11.3333C3.0347 11.3333 3.33316 11.6318 3.33316 12Z" stroke={isTableView ? "#ffffff" : "#81766F"} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </div>
                        </div>
                        <select className='notebook-genai-filterSort' name={`notebook-filterSort`} id={`notebook-filterSort`} onChange={(e) => handleChangeSelectSortBy(e)} value={sortByValue}>
                            <option value="MostRecent">Most Recent</option>
                            <option value="Alphabetical">Alphabetical</option>
                        </select>
                        {/* <button className='notebook-genai-filterSort' aria-haspopup="listbox" aria-label="Sort by">
                                <span className='notebook-genai-filterTtitle'>Most Relevant</span>
                                <span className='notebook-genai-chev' ><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                    <path d="M4 6L8 10L12 6" stroke="#81766F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                </svg></span>
                            </button> */}
                        <button className='notebook-genai-createBtn' onClick={() => setCreateNoteBook(true)}>
                            <span className='notebook-genai-createIcon'>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                    <path d="M7.99975 3.33333V12.6667M3.33325 8H12.6663" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </span>
                            Create New
                        </button>
                    </div>
                </nav>}

                {isTableView ? <main className='notebook-genai-main' role="main">
                    <TableNoteBook sampleProjects={sampleProjects} handleViewExisting={handleViewExisting} handleDeleteExisting={handleDeleteExisting} />
                </main> : <main className='notebook-genai-main' role="main">
                    <h2 className='notebook-genai-sectionTitle'>My Projects</h2>
                    <BoxViewNotebook handleCreateNoteBook={handleCreateNoteBook} sampleProjects={sampleProjects} handleViewExisting={handleViewExisting} handleDeleteExisting={handleDeleteExisting} />
                </main>}
                {sampleProjects && sampleProjects.length > 0 &&
                    <div className='gen-ai-pagination-section'>
                        <Pagination
                            metadata={parseInt(projectDocumentCount)}
                            handlePageChange={handlePageChange}
                            itemsPerPage={projectItemsPerPage}
                            page={parseInt(projectCurrentPage)}
                            customWidth={customWidth}
                            customHeight={customHeight}
                        /></div>}

                {/*(isFromCreate || isExistingProject) && <NoteBookAuthoringIndex
                        attachedFiles={attachedfile}
                        selectedProjectType={selectedProjectType}
                        sessionID={sessionId}
                        noteBookName={noteBookName}
                        isExistingProject={isExistingProject}
                    />*/}

                {(createNoteBook) && <CreateNBGenAIModal
                    showModal={createNoteBook}
                    handleClose={() => { setCreateNoteBook(false) }}
                    handleCreateNew={handleCreateNew} />}
                {alertMessageShowModal && <AlertMessagePopUpModal color={alertMessageModelColor} content={alertMessageContent} showModal={alertMessageShowModal} handleClose={() => closeAlertMessage()} />}
            </div>
            <footer className="">
                <GenAIHomeFooter />
            </footer>
            {(isProjectProcessing) &&
                <Modal
                    show={isProjectProcessing}
                    size="lg md sm xs"
                    centered
                    aria-labelledby="contained-modal-title-vcenter"
                    dialogClassName="savePopUp"
                    className="gen-ai-answering-search-spinner-popup"
                    backdropClassName="z-index-gen-ai-answering-search-spinner-popup"
                    scrollable={true}>
                    <div style={{ padding: "0 5%" }}>
                        <div style={{ fontSize: "14px", textAlign: "center" }}>
                            <Modal.Body>
                                <img src={imsLoader} alt="" width={100} height={100} />
                                <div className="saveModal-heading" style={{ color: "#EB1700" }}>{spinnerMessage ? spinnerMessage : `Please wait while finding answers.`} </div>
                            </Modal.Body>
                        </div>
                    </div>
                </Modal>}
        </>
    );
}
